import * as e from "react";
import a from "../lib/IconBase.es.js";
import i from "../defs/FileText.es.js";
const o = e.forwardRef((t, r) => /* @__PURE__ */ e.createElement(a, { ref: r, ...t, weights: i }));
o.displayName = "FileTextIcon";
const s = o;
export {
  s as FileText,
  o as FileTextIcon
};
